import { api } from '@cloudsuite/theme_library/scripts/helper';

const formatPrice = price => parseFloat(price).toFixed(2);

const SHOP_CONSTANTS = { ...document.querySelector('[data-js-shopconstants]').dataset };

class GTM {
  static init() {
    this.shopid = this.shopid.bind(this);
    this.basketView = this.basketView.bind(this);
    this.cartProducts = this.cartProducts.bind(this);
    this.productImageUrl = this.productImageUrl.bind(this);
  }

  static shopid() {
    window.dataLayer.push({
      shopid: SHOP_CONSTANTS.shopId
    });
  }

  static basketView(pageType, totalValue, products) {
    window.dataLayer.push({
      id: products,
      pagetype: pageType,
      totalvalue: formatPrice(totalValue)
    });
  }

  static getSmallProductData(products) {
    return products.map(function (p) {
      return {
        id: p.code,
        name: p.name,
        quantity: p.quantity,
        unitPrice: p.unit_price,
        brand: p.brand_name,
      };
    })
  }

  static getBasketProducts() {
    try {
      return JSON.parse(document.querySelector('[data-js-basket-products]').dataset.jsBasketProducts);
    } catch (e) {
      return [];
    }
  }

  static cartProducts() {
    window.dataLayer.push({
      event: "shoppingCartStatus",
      cartProducts: [...GTM.getSmallProductData(GTM.getBasketProducts())],
    });
  }

  static productImageUrl() {
    var linkToImg = $(".js-product-image-slider a:has(img):first");
    if (linkToImg.length) {
      window.dataLayer.push({
        productImageURL: linkToImg.attr("href")
      });
    }
  }
}


class EEC {
  static async _addToCart(oldQty, newQty, ega, trigger) {
    if (ega.treeID) {
      const request = await api.get(trigger.closest('[data-tree-parents-url]').data("tree-parents-url").replace('999999', ega.treeID))
      .then((trees) => {
          return trees.map(tree => tree.name).join('/');
      });   
  
      ega['category'] = `${request}/${ega.tree_name}`; 
    }
    
    const clickTrigger = () => {
      const triggerEvent = trigger.closest('[data-js-ga-trigger]').attr('data-js-ga-trigger');
      let triggerValue;
      if (window.innerWidth < 768) {
        triggerValue = `${triggerEvent}_mobile`;
      } else {
        triggerValue = `${triggerEvent}_desktop`;
      }

      return triggerValue;
    }

    window.dataLayer.push({
      event: "addToCart",
      location: window.location.href,
      ...trigger ? {details: clickTrigger()} : [],
      cartProducts: [...GTM.getSmallProductData(GTM.getBasketProducts())],
      ecommerce: {
        currencyCode: SHOP_CONSTANTS.currencyCode,
        add: {
          products: [{
            name: ega.name,
            id: ega.id,
            price: formatPrice(ega.price),
            brand: ega.brand,
            category: ega.category,
            ...(ega.kleur ? {"kleur": ega.kleur} : []),
            ...(ega.kleurstaal ? {"kleurstaal": ega.kleurstaal} : []),
            ...(ega.material ? {"material": ega.material} : []),
            ...(ega.stijl ? {"stijl": ega.stijl} : []),
            variant: ega.variant,
            quantity: 1
          }]
        }
      }
    });
  }

  static _removeFromCart(oldQty, newQty, ega) {
      window.dataLayer.push({
      event: "removeFromCart",
      cartProducts: [...GTM.getSmallProductData(GTM.getBasketProducts())],
      ecommerce: {
        currencyCode: SHOP_CONSTANTS.currencyCode,
        remove: {
          products: [{
            name: ega.name,
            id: ega.id,
            price: formatPrice(ega.price),
            brand: ega.brand,
            category: ega.category,
            variant: ega.variant,
            quantity: oldQty - newQty
          }]
        }
      }
    });
  }

  static addOrUpdateCart() {
    $(document).on("click", '.order-form button[type="submit"]', function (e) {
      var form = $(this).parents('.order-form').length ? $(this).parents('.order-form') : $(this).parents('.basket-product-quantity-container'),
        detail = $(".js-ga-product-detail"),
        ega = detail.length ? detail.data("ega") : form.data('ega'),
        quantity = $(form).find("input[name=quantity]"),
        oldQuantity = $(form).find("input[name=current_quantity]"),
        oldQty = +oldQuantity.val(),
        newQty = +quantity.val();

      $('#js-order-modal').on('show.bs.modal', function () {
        if (oldQty <= newQty) {
          EEC._addToCart(oldQty, newQty, ega);
        } else {
          EEC._removeFromCart(oldQty, newQty, ega);
        }
      });
    });
  }

  static keuzeWijzer() {
    const button = document.querySelector('[data-advisor-id]');
    
    if (button) {
      button.addEventListener('click', (e) => {
        const id = () => {
          const attr = e.target.getAttribute('data-advisor-id');
            switch(attr) {
              case '212bc422-11f4-4e79-8e3a-e0ba1abf20c3':
                return `${attr} - matrassen`;
              case '3abde4e4-31f7-4c7b-ad7f-c7c12bcec98d':
                return `${attr} - kussens`;
              case 'b6d099dd-a8ce-4d7a-aae6-48ddff503338':
                return `${attr} - relaxstoelen`;
              case 'dbe1c92d-90a4-4356-8258-d4dce72a385b':
                return `${attr} - woonstijl`;
              default:
                break;
            }
        } 

        window.dataLayer.push({
          'event': "keuzehulp_start",
          'location': window.location.href,
          'type_test': id()
        });
      })
    }
  }

  static wishListRegistration() {
    const wishlistButtons = document.querySelectorAll('[data-js-wishlist-gtm]');
    window.dataLayer = window.dataLayer || [];
    
    if (wishlistButtons.length) {
      wishlistButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          if (e.currentTarget.classList.contains('btn__custom')) {
            window.dataLayer.push({
              'event': "wishlistpopup_account_aanmaken",
              'location': window.location.href,
            });
          } else {
            window.dataLayer.push({
              'event': "wishlistpopup_log_in",
              'location': window.location.href,
            });

          }
        });
      });
    }   
  }

  static downloadsFromPdp() {
    const downloadBtn = document.querySelector('[data-js="ga-downloads-pdp"]');
     
    if (downloadBtn) {
      const data = downloadBtn.closest('.data-js-product');
      const ega = JSON.parse(data.getAttribute('data-ega'));
      const delivery = data.querySelector('[data-js-ga-delivery-days]');

      downloadBtn.addEventListener('click', () => {
        window.dataLayer.push({
          'event': 'PDP_download_uitvoeringen',
          'id': ega.id,
          'price': ega.price,
          'brand': ega.brand,
          'category': ega.category,
          'kleur': ega.kleur,
          'kleurstaal': ega.kleurstaal,
          'material': ega.material,
          'stijl': ega.stijl,
          'variant': ega.variant,
          'delivery_text': delivery.querySelector('p').innerText,
          'delivery_days': JSON.parse(delivery.getAttribute('data-js-ga-dd')),
          'stock_quantity': JSON.parse(delivery.getAttribute('data-js-ga-stock')),
        });
      });
    }
  }

  static pdpStickyStoreAppointment() {
    const stickyBtton = document.querySelector('[data-js="pdp-sticky-orderform"]');

    if (stickyBtton) {
      stickyBtton.addEventListener('click', (e) => {
        const data = e.currentTarget.getAttribute('data-ega');
        const ega = JSON.parse(data);
        const delivery = document.querySelector('.js-ga-product-detail [data-js-ga-delivery-days]');

        window.dataLayer.push({
          'event': 'PDP_winkelafspraak_stickybtn_desktop',
          'id': ega.id,
          'price': ega.price,
          'brand': ega.brand,
          'category': ega.category,
          'kleur': ega.kleur,
          'kleurstaal': ega.kleurstaal,
          'material': ega.material,
          'stijl': ega.stijl,
          'variant': ega.variant,
          'delivery_text': delivery.querySelector('p').innerText,
          'delivery_days': JSON.parse(delivery.getAttribute('data-js-ga-dd')),
          'stock_quantity': JSON.parse(delivery.getAttribute('data-js-ga-stock')),
        });
      });
    }
  }
}

EEC.keuzeWijzer();
EEC.wishListRegistration();
EEC.downloadsFromPdp();
EEC.pdpStickyStoreAppointment();

window.GTM = GTM;
window.EEC = EEC;